import { ABSD, FinancingLoanType, PAGE } from '@/constants/common';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FormTypes } from '.';
import {
  CASH,
  DEFAULT_LOAN_DETAILS_AGE_65,
  HousingLoanType,
} from '@/constants/hdb-resale/purchase';
import * as baseConfig from '@/config/base-config.json';
import * as config from '@/config/config.json';

export const initialState = {
  formField: {
    purchasePrice: 0,
    valuationPrice: 0,
    totalAvailableCpfOa: 0,
    cpfHousingGrant: 0,
    enhancedHousingGrant: 0,
    proximityHousingGrant: 0,
    optionFee: baseConfig.option_fee_cash.default,
    optionExerciseFee: baseConfig.option_exercise_fee_cash.default,
    absd: ABSD.LIST[0].value,
    legalFee: baseConfig.legal_fee,
    resaleApplicationFee: config.resale_application_fee.option_2.toString(),
    valuationFee: baseConfig.hdb_valuation_fee,
    serviceCommission: baseConfig.service_commission_in_percent,
    gst: config.gst_rate,
    others: 0,
    housingLoanType: HousingLoanType.BANK_LOAN,
    loanType: FinancingLoanType.sixtyFiveYearLoan,
    loanTenure: DEFAULT_LOAN_DETAILS_AGE_65.LOAN_TENURE,
    mortgageLoanInterestRate: baseConfig.mortgage_interest_rate.hdb.default,
    loanToValue: DEFAULT_LOAN_DETAILS_AGE_65.LOAN_TO_VALUE_DEFAULT,
    cash: CASH.FIVE_PERCENT,
    isMonthlyPayable: true,
    otpDate: new Date().toString(),
    exercisePeriod: baseConfig.exercise_period_in_days.default,
    submitOfResaleApplication: baseConfig.submit_resale_application_in_days.default,
    acceptanceOfResaleApplication: baseConfig.acceptance_resale_application_in_days.default,
    temporaryExtensionOfStay: baseConfig.temporary_extension_stay_in_months.default,
  },
  loading: true,
  from: '' as PAGE | '',
};

export const purchaseSlice = createSlice({
  name: 'hdbResalePurchase',
  initialState,
  reducers: {
    updateDataForm: (
      state,
      action: PayloadAction<
        FormTypes & {
          from: PAGE | '';
        }
      >,
    ) => {
      const { from, ...rest } = action.payload;

      state.formField = rest;
      state.from = action.payload.from;
    },
    updateFrom: (state, action: PayloadAction<PAGE>) => {
      state.from = action.payload;
    },
    reset: () => {
      return initialState;
    },
  },
  extraReducers: () => {},
});

export const { updateDataForm, updateFrom, reset } = purchaseSlice.actions;

export default purchaseSlice.reducer;
